import { render, staticRenderFns } from "./CreateNewRole.vue?vue&type=template&id=5e5e3f33&"
import script from "./CreateNewRole.vue?vue&type=script&lang=js&"
export * from "./CreateNewRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports